import { APINodeClient } from './apiNodeCore';

const api = new APINodeClient();





export const getSystemResponseApi = async ({
  file,
  transcript,
  entry_json,
  detected_language,
  time_difference,
  previous_agent_log_id,
  page,
}: {
  file: File;
  transcript: string;
  entry_json: any,
  detected_language: string | null,
  time_difference: number,
  previous_agent_log_id: number,
  page: string | null,
}) => {
  const formData = new FormData();
  formData.append("file", file);

  if (transcript) {
    formData.append("transcript", transcript); // ✅ Send as JSON string
  }
  if (entry_json) {
    formData.append("entry_json", JSON.stringify(entry_json)); // ✅ Send as JSON string
  }
  if (page) {
    formData.append("page", page); // ✅ Send as JSON string
  }

  if (detected_language) {
    formData.append("detected_language", detected_language); // ✅ Send as JSON string
  }

  if (time_difference !== undefined && time_difference !== null) {
    formData.append("time_difference", String(time_difference)); // ← number → string
  }

  if (previous_agent_log_id !== undefined && previous_agent_log_id !== null) {
    formData.append("previous_agent_log_id", String(previous_agent_log_id)); // ← number → string
  }


  return api.createWithFileForAudio('/model/classify-hotel-intent', formData);
};


export const sendApproveEntryApi = async (response: any) => {
  return api.create('/model/approve-entry', response);
};



export const sendIdentityDocumentApi = async ({
  front, back
}: {
  front: File;
  back?: File
}) => {
  const formData = new FormData();
  formData.append("front", front);
  if (back) {
    formData.append("back", back);
  }
  // 👈 field name must match backend
  // if (caption) formData.append("caption", caption);

  return api.createWithFileForAudio('/model/identity-image', formData);
};

export const deleteIdentityDocumentApi = async ({
  image_path,
  docType,
  guest
}: {
  image_path: string;
  docType?: string;
  guest: any
}) => {
  // const formData = new FormData();
  // console.log("deleteIdentityDocumentApi called with:" , image_path, docType);
  // formData.append("image_path", image_path); // field name expected by backend
  // if (docType) {
  //   formData.append("docType", docType); // optional
  // }

  // Call backend endpoint to delete document
  return api.create("/model/delete-identity-image", { image_path, docType, guest });
};

export const getInitialStateApi = async () => {
  return api.get('/getInitialState');
};


export const downloadDbFiles = async (): Promise<void> => {
  return api.triggerFileDownload('download/downloadDbFiles');
};


// export const downloadInvoiceApi = async (response: any) => {
//   return .....??('/download/invoices/pdf',response);
// };


// api method you call from your UI
export const downloadInvoiceApi = async (payload: any): Promise<void> => {
  const fallbackName = `invoice_${istTimestamp()}.pdf`;
  return api.downloadFile('/download/invoices/pdf', {
    method: 'POST',
    data: payload,
    headers: { 'Content-Type': 'application/json' },
    defaultFilename: fallbackName,
  });
};


export const downloadGuestDataApi = async (): Promise<void> => {
  const fallbackName = `guest_data_${istTimestamp()}.xlsx`;
  return api.downloadFile('/download/guests/xlsx', {
    method: 'GET',
    defaultFilename: fallbackName
  });
};



const istTimestamp = () => {
  const fmt = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit",
    hour12: false,
  });
  const [d, t] = fmt.format(new Date()).split(", "); // "dd/mm/yyyy", "HH:MM:SS"
  const [dd, mm, yyyy] = d.split("/");
  return `${yyyy}-${mm}-${dd}_${t.replace(/:/g, "-")}`;
};





export const sendManuallyUpdatedEntryApi = async (response: any) => {
  return api.create('/model/manual-update', response);
};
